module.exports = __webpack_public_path__ + "static/media/credit-suisse-logo-charcoal.9114345f.svg";